import {FunctionComponent} from "react";

const ContextoActual:FunctionComponent = () => {
    return (<h1>"ContextoActual"</h1>);
}
export  default ContextoActual;